import { DevTools as JotaiDevtools } from 'jotai-devtools';
import { Helmet } from 'react-helmet';
import { type QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

import { GlobalStyles } from '@soluto-private/mx-asurion-ui-react';

import { FlowManagerProvider } from '@service-initiation/shared-data-access-flow-manager';
import { I18nProvider } from '@service-initiation/shared-data-access-i18n';
import { useFooter } from '@service-initiation/shared-ui-footer';
import { queryClient } from '@service-initiation/shared-utils-query-client';
import { useReserveWithGoogle } from '@service-initiation/tech-care-data-access-reserve-with-google';
import { Route } from '@service-initiation/tech-care-data-access-routing';
import { AlertBanner } from '@service-initiation/tech-care-ui-alert-banner';
import { Header } from '@service-initiation/tech-care-ui-header';
import { Layout } from '@service-initiation/tech-care-ui-layout';

import { i18nClient } from '../initializations/initi18n';
import { Router } from '../router/Router';
import { defaultFlow } from '../router/flows';

const BASE_NAME = '/tech-care';

export const App = () => {
  useFooter();
  useReserveWithGoogle();

  return (
    <>
      <Helmet>
        <title>
          Repair Your Device | iPhone, Cell Phone, Samsung, Computer and Tablet
        </title>
        <meta content="noindex,nofollow" name="robots" />
      </Helmet>

      <I18nProvider i18n={i18nClient}>
        <QueryClientProvider client={queryClient as unknown as QueryClient}>
          {process.env.NX_PUBLIC_SHOW_DEV_TOOLS === 'true' ? (
            <>
              <ReactQueryDevtools
                initialIsOpen={false}
                position="bottom-right"
              />
              <JotaiDevtools />
            </>
          ) : null}

          <GlobalStyles />
          <Layout>
            <Header />
            <AlertBanner />

            <FlowManagerProvider
              baseName={BASE_NAME}
              flow={defaultFlow}
              rootPath={Route.Landing}
            >
              <Router baseName={BASE_NAME} />
            </FlowManagerProvider>
          </Layout>
        </QueryClientProvider>
      </I18nProvider>
    </>
  );
};
